import React from 'react';

import {cn} from '../lib/helpers';

import {flex, flexWrapStyle} from './flex.module.css';

const Flex = ({children, as: As = 'div', flexWrap, className, ...rest}) => {
  return (
    <As
      className={cn(flex, flexWrap === 'wrap' && flexWrapStyle, className)}
      {...rest}
    >
      {children}
    </As>
  );
};

export default Flex;
